/** Actions */
export const ON_FETCH_REPOSITORIES = 'ON_FETCH_REPOSITORIES';
export const ON_FETCH_REPOSITORIES_SUCCESS = 'ON_FETCH_REPOSITORIES_SUCCESS';
export const ON_FETCH_REPOSITORIES_FAILURE = 'ON_FETCH_REPOSITORIES_FAILURE';

export const FILTER_BY_CONTRIBUTIONS = 'FILTER_BY_CONTRIBUTIONS';
export const FILTER_BY_REPOS = 'FILTER_BY_REPOS';
export const FILTER_BY_GISTS = 'FILTER_BY_GISTS';
export const FILTER_BY_FOLLOWERS = 'FILTER_BY_FOLLOWERS';

/** Action creators */

export function onFetchRepos() {
  return { type: ON_FETCH_REPOSITORIES };
}

export function onFetchReposSuccess(repos: any) {
  return { type: ON_FETCH_REPOSITORIES_SUCCESS, repos };
}

export function onFetchReposFailure() {
  return { type: ON_FETCH_REPOSITORIES_FAILURE };
}

export function filterByContributions() {
  return { type: FILTER_BY_CONTRIBUTIONS };
}

export function filterByRepos() {
  return { type: FILTER_BY_REPOS };
}

export function filterByGists() {
  return { type: FILTER_BY_GISTS };
}

export function filterByFollowers() {
  return { type: FILTER_BY_FOLLOWERS };
}
